import React from 'react';
import LazyLoad from 'react-lazyload';
import styled from 'styled-components';

const LazySection: React.FC<{ disabled?: boolean }> = ({
  children,
  disabled,
}) => {
  return !disabled ? (
    <LazyLoad style={{ width: '100%' }} height={500} offset={50} once>
      {children}
    </LazyLoad>
  ) : (
    <StyledContainer>{children}</StyledContainer>
  );
};

const StyledContainer = styled.div``;

export default LazySection;
